import React from "react";

export const Custom = (props) => {

    return (
        <>
        <div dangerouslySetInnerHTML={{ __html: props.slice.primary.code }} />
        </>
    )
}